import camelCase from '@/common/camel-case';
import type { KnownError, KnownExceptionKey } from '@/types';

export default class ZvdZError extends Error {
  readonly response: Response;

  constructor(response: Response) {
    super();

    this.response = response;
  }

  async getInfo(): Promise<KnownError | undefined> {
    try {
      const json = (await this.response.json()) as Record<string, unknown>;
      if (!json.KnownError && !json.knownError) {
        return undefined;
      }
      const errorData = Object.fromEntries(
        Object.entries(
          (json.KnownError || json.knownError) as Record<string, unknown>,
        ).map(([key, value]) => [camelCase(key), value]),
      );
      return {
        key: errorData.key as keyof KnownExceptionKey,
        description: errorData.description as string,
        metaData: errorData.metadata as Record<string, unknown> | undefined,
      };
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      return undefined;
    }
  }
}
